module.exports = __webpack_public_path__ + "img/notification_failed.42e6fbe4.svg";